export default (fields = {}) =>
  ['line1', 'line2', 'line3', 'town', 'region', 'postalCode']
    .reduce((acc, field) => (fields[field] ? [...acc, fields[field]] : acc), [])
    .join(', ');
